import React from 'react';
import ReactDatatable from '@ashvin27/react-datatable';
import axios from 'axios';
import { Card, CardBody, Col } from 'reactstrap';
import { baseURL, baseURL_Radio_Compaign } from '../../_helpers';
import * as moment from 'moment';
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker'
import { FormControl } from 'react-bootstrap'
import { TOKEN } from '../../_helpers/token';
import { func } from 'prop-types';

export class CompaignDeposits extends React.Component {
    constructor(props) {
        super(props);
        this.applyCallback = this.applyCallback.bind(this);
        this.columns = [
            {
                key: "date",
                TrOnlyClassName: 'tsc',
                text: "Date",
                className: "tsc",
                align: "left"
            },
            {
                key: "mcount",
                TrOnlyClassName: 'tsc',
                text: "Count",
                className: "tsc",
                align: "left"
            },
            {
                key: "mcustomers",
                TrOnlyClassName: 'tsc',
                text: "Customers",
                className: "tsc",
                align: "left"
            },
            {
                key: "amount",
                TrOnlyClassName: 'tsc',
                text: "Amount",
                className: "tsc",
                align: "left"
            },
        ];
        this.config = {
            key_column: "tsc",
            length_menu: [100, 200, 500],
            show_filter: false,
            show_pagination: true,
            pagination: 'advance',
            page_size: 100,
            show_length_menu: true,
            language: {
                loading_text: "Please be patient while data loads...",
                no_data_text: "No record was found",
                filter: "Enter date (YYYY-MM-DD)",
                pagination: {
                    next: <span>&#9658;</span>,
                    previous: <span>&#9668;</span>
                    // next
                    // previous
                }
            },
            button: {
                excel: true,
                print: false,
                csv: true
            }
        }
        this.state = {
            admins: [],
            isLoading: true,
            showError: false,
            isShowError: false,
            showComponent: false,
            hideComponent: false,
            data: [],
        };
        let now = new Date();
        let start = moment.utc(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0));
        let end = moment.utc(start).add(1, "days").subtract(1, "seconds");
        this.state = {
            start: start,
            end: end,
            show_page: true,
            isPageLoad: true,
        }
    }

    componentDidMount() {

        this.setState({
            startDate: moment.utc(new Date()).subtract(1, "days").format('DD MMM, YYYY'),
            endDate: moment.utc(new Date()).subtract(1, "days").format('DD MMM, YYYY'),
            // isPageLoad: true,
            valuedate: moment.utc(new Date()).subtract(1, "days").format('DD MMM, YYYY') + " " + moment.utc(new Date()).subtract(1, "days").format('DD MMM, YYYY')
        })

        this.getData("filter_value=&page_number=1&page_size=100&sort_order=false", moment.utc(new Date()).subtract(1, "days").format('YYYY-MM-DD'),
            moment.utc(new Date()).subtract(1, "days").format('YYYY-MM-DD'))
    }

    getData = (queryString, startDate, endDate) => {

        let url = baseURL_Radio_Compaign + `campaign_deposit_report?keyword=${this.state.keyword}&start_date=${startDate}&end_date=${endDate}&${queryString}`;
        var sha512 = require('js-sha512');
        console.log("URL", url)
        let signature = sha512(this.state.keyword + 'P@s5w0rd_5@lt')
        this.setState({
            isLoading: true,
        })
        axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                "Access-Control-Allow-Origin": "*",
                'signature': signature
            }
        }).then((response) => {
            this.setState({
                mdata: response.data.deposits,
                mtotal: 100 * response.data.page_count,
                isLoading: false,
            },
                function () {
                    var data = [];
                    if (this.state.mdata.length > 0) {
                        for (let i = 0; i < this.state.mdata.length; i++) {
                            let mcount = { mcount: this.state.mdata[i].count };
                            let mcustomers = { mcustomers: this.state.mdata[i].customers };

                            data.push(Object.assign(mcount, mcustomers, this.state.mdata[i]));
                            this.setState({
                                data: data
                            })
                            console.log("bugs", data);
                        }
                    } else {
                        this.setState({
                            data: data,
                            isLoading: false,

                        })
                        console.log("bugs", data);
                    }
                }
            );
            // alert(JSON.stringify(response.data))
        }).catch((error) => {
            var data = [];

            this.setState({
                data: data,
                isLoading: false,

            })
        })
    }


    applyCallback(startDate, endDate) {

        localStorage.setItem("STARTDATE", startDate)
        localStorage.setItem("ENDDATE", endDate)
        let Sdate1 = moment.utc(startDate).format('DD MMM, YYYY');
        let Edate2 = moment.utc(endDate).format('DD MMM, YYYY');
        this.setState({
            valuedate: Sdate1 + " " + Edate2,
            startDate: Sdate1,
            isPageLoad: true,
            endDate: Edate2
        })

        this.getData("filter_value=&page_number=1&page_size=100&sort_order=false", moment.utc(startDate).format('YYYY-MM-DD'), moment.utc(endDate).format('YYYY-MM-DD'));
    }


    tableChangeHandler = data => {
        let queryString = Object.keys(data).map((key) => {
            if (key === "sort_order" && data[key]) {
                return encodeURIComponent("sort_order") + '=' + encodeURIComponent(data[key].order) + '&' + encodeURIComponent("sort_column") + '=' + encodeURIComponent(data[key].column)
            } else {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            }

        }).join('&');

        this.getData(queryString, moment.utc(localStorage.getItem("STARTDATE")).format('YYYY-MM-DD'), moment.utc(localStorage.getItem("ENDDATE")).format('YYYY-MM-DD'))


    }

    // onKewywordChange (value){
    //     this.setState({
    //         keyword: 
    //     })
    // }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    getDataUpdate() {
        let queryString = ("filter_value=&page_number=0&page_size=10&sort_order=false")

        this.getData("filter_value=&page_number=1&page_size=100&sort_order=false", moment.utc(new Date()).subtract(1, "days").format('YYYY-MM-DD'),
            moment.utc(new Date()).subtract(1, "days").format('YYYY-MM-DD'))
        // this.getData("", moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'), moment.utc(new Date()).subtract(2, 'hours').format('YYYY-MM-DD'))
    }


    onSubmitKeyWord() {

        this.setState({

            keyword: this.state.keyword,
            show_page: false

        }, function () {

            this.getData("filter_value=&page_number=1&page_size=100&sort_order=false", moment.utc(new Date()).subtract(1, "days").format('YYYY-MM-DD'),
                moment.utc(new Date()).subtract(1, "days").format('YYYY-MM-DD'))


        })
    }

    render() {

        let ranges = {
            "Today Only": [moment.utc(this.state.start), moment.utc(this.state.end)],
            "Yesterday Only": [
                moment.utc(this.state.start).subtract(1, "days"),
                moment.utc(this.state.end).subtract(1, "days")
            ],
            "3 Days": [moment.utc(this.state.start).subtract(3, "days"), moment.utc(this.state.end)],
            "5 Days": [moment.utc(this.state.start).subtract(5, "days"), moment.utc(this.state.end)],
            "1 Week": [moment.utc(this.state.start).subtract(7, "days"), moment.utc(this.state.end)],
            "2 Weeks": [moment.utc(this.state.start).subtract(14, "days"), moment.utc(this.state.end)],
            "1 Month": [moment.utc(this.state.start).subtract(1, "months"), moment.utc(this.state.end)],
            "1 Year": [moment.utc(this.state.start).subtract(1, "years"), moment.utc(this.state.end)]
        };
        let local = {
            "format": "DD-MM-YYYY",
            "sundayFirst": false
        }

        const { show_page } = this.state

        return (
            <div >
                < >
                    <div className="row">
                        <div className="col-md-8">

                        <div className="col-md-8">
                            <h4>Campaign Deposit Report</h4><br />
                            <div className="row">
                                <div className="col-6">
                                    <FormControl
                                        type="text"
                                        value={this.state.keyword}
                                        label="Text"
                                        name="keyword"
                                        onChange={this.handleChange}
                                        placeholder="Enter keyword to retrieve report"
                                    />

                                </div>
                                <div className="col-6 float-left">

                                    <button className=" float-left btn btn-primary btn-sm" onClick={e => {
                                        this.onSubmitKeyWord();
                                    }} >Submit</button>
                                    {/* <input id="input" type="text" readOnly /> */}
                                </div>
                            </div>
                        </div>
                        </div>
                        <div className="col-md-4">
                        </div>
                    </div><br />

                    {show_page === false ?
                        < Card >
                            <CardBody >
                                
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="col-md-8">
                                            <div className="row">
                                                <div className="col-6">
                                                    <DateTimeRangeContainer
                                                        ranges={ranges}
                                                        start={moment.utc(this.state.start).subtract(1, "days")}
                                                        end={this.state.end}
                                                        local={local}
                                                        applyCallback={this.applyCallback}>
                                                        <FormControl
                                                            id="formControlsTextB"
                                                            type="text"
                                                            value={this.state.valuedate}
                                                            label="Text"
                                                            placeholder="Filter by Date"
                                                        />
                                                    </DateTimeRangeContainer>
                                                </div>
                                                <div className="col-6 float-left">

                                                    <button className=" float-left btn btn-primary btn-sm" onClick={e => {
                                                        this.getDataUpdate();
                                                        this.setState({
                                                            startDate: moment.utc(new Date()).subtract(1, "days").format('DD MMM, YYYY'),
                                                            endDate: moment.utc(new Date()).subtract(1, "days").format('DD MMM, YYYY'),
                                                            valuedate: moment.utc(new Date()).subtract(1, "days").format('DD MMM, YYYY') + " "
                                                                + moment.utc(new Date()).subtract(1, "days").format('DD MMM, YYYY')
                                                        })
                                                    }} >Clear</button>
                                                    {/* <input id="input" type="text" readOnly /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                    </div>
                                </div><br />
                                <div className="panel-body" >
                                    <br />

                                    <ReactDatatable
                                        config={this.config}
                                        records={this.state.data}
                                        columns={this.columns}
                                        dynamic={true}
                                        id="tsc"
                                        loading={this.state.isLoading}
                                        total_record={this.state.mtotal}
                                        onChange={this.tableChangeHandler} />
                                </div>
                            </CardBody>

                        </Card>
                        : null}
                </>
            </div>

        )
    }
}